// Utilidad para traducir el rol a español

const translateRole = role => {
    switch (role) {
        case 'Tourist':
            return 'Turista';
        case 'Owner':
            return 'Prestador Turístico';
        default:
            return 'Rol indefinido'
    }
};

export default translateRole;


// WEBPACK FOOTER //
// ./src/utils/translateRole.js